import {
  getAccount_account,
  getAccount_account_patients_edges_node
} from "../../../graphql/types/getAccount";
import { SignUpPaths } from "..";

export const getRedirectTo = ({
  account,
  patient,
  accountComplete
}: {
  account: getAccount_account;
  patient: getAccount_account_patients_edges_node | null;
  accountComplete?: boolean;
}) => {
  // If the account is complete or we have an account with a traced
  // patient and a practice, (i.e. they've completed the flow) do not
  // let the patient re-enter the sign up flow
  if (
    accountComplete ||
    (!!account &&
      !!patient &&
      !!patient.nhsNumber &&
      !!patient.practice &&
      !!patient.practice.id)
  ) {
    return "/";
  }
  // If an account has been set up but there is no confirmed email,
  // redirect to the email confirmation page
  if (!!account.email && !account.verifiedEmail) {
    return SignUpPaths.SIGNUP_EMAIL_VERIFICATION;
  }
  // If patient has a verified email but not a verified phone,
  // redirect to the add phone page
  else if (account.verifiedEmail && !account.verifiedPhone) {
    return SignUpPaths.SIGNUP_ADD_PHONE;
  }
  // If there is a patient but no nhs number and no pds trace or retrieval
  // attempts remaining, redirect to contact patient care
  else if (
    !!patient &&
    !patient.nhsNumber &&
    !patient.pdsTraceAttemptsRemaining &&
    !patient.pdsRetrieveAttemptsRemaining
  ) {
    return SignUpPaths.SIGNUP_CONTACT_PATIENT_CARE;
  }
  // If  there no patients on the account or none with an nhs number,
  // redirect to selecting patient details option
  else if ((!patient || !patient.nhsNumber) && account.verifiedPhone) {
    return SignUpPaths.SIGNUP_NHS_NUMBER;
  }
  // If there is a patient with an NHS number but no practice set,
  // redirect to the confirm GP step
  if (!!patient && !!patient.nhsNumber && !patient.practice) {
    return SignUpPaths.SIGNUP_CONFIRM_GP;
  }
};
